"use strict";

var _require = require('../../products/components'),
    WaxSeal = _require.WaxSeal,
    VellumJacket = _require.VellumJacket,
    RibbonSpool = _require.RibbonSpool;

function hasEmbellishments(printJob) {
  var doesHaveEmbellishments = false;
  printJob.products.forEach(function (product) {
    return product.subcomponents().forEach(function (component) {
      [WaxSeal, VellumJacket, RibbonSpool].forEach(function (Embellishment) {
        if (Object.prototype.isPrototypeOf.call(Embellishment.prototype, component)) {
          doesHaveEmbellishments = true;
        }

        if (component.acc_ribbon && component.acc_ribbon !== 'None') {
          doesHaveEmbellishments = true;
        }
      });
    });
  });
  return doesHaveEmbellishments;
}

module.exports = hasEmbellishments;